// extracted by mini-css-extract-plugin
export var container = "_4n-0";
export var infoButton = "_4n-1";
export var label = "_4n-3";
export var labelExpanded = "_4n-4";
export var price = "_4n-5";
export var priceExpanded = "_4n-6";
export var title = "_4n-2";